// extracted by mini-css-extract-plugin
export default {"login":"LoginPage_login__MRc+M","button":"LoginPage_button__jx8GS","form":"LoginPage_form__8gH2m"};